import { render } from "./app-timeline.vue?vue&type=template&id=18445a5c"
import script from "./app-timeline.vue?vue&type=script&lang=js"
export * from "./app-timeline.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/timeline/app-timeline.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18445a5c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18445a5c', __exports__)) {
    console.log('reload')
    api.reload('18445a5c', __exports__)
  }
  
  module.hot.accept("./app-timeline.vue?vue&type=template&id=18445a5c", () => {
    console.log('re-render')
    api.rerender('18445a5c', render)
  })

}


export default __exports__